module.exports = __webpack_public_path__ + "media/assets/images/icons/client-resp-icon-b5e54b7535fb4be372d9f3576b6c16ac.svg";